import React from 'react';
import { IThumbnail } from 'utils/entities';
import { TransformedImage } from 'components/transformed-image';
import * as Styled from './styled';
import { useWindowSize } from 'hooks/useWindowSize';

interface ImageGalleryItemProps {
  shouldLoad: boolean;
  useWidth?: boolean;
  thumbnail: IThumbnail;
}

export const ImageGalleryItem: React.FC<ImageGalleryItemProps> = ({ shouldLoad, thumbnail, useWidth }) => {
  const { url, description, rotateDegrees } = thumbnail;
  const [ windowWidth ] = useWindowSize({ unsafelyForSSRInitialize: true });

  const imageOptions = useWidth ? { rotateDegrees, width: windowWidth } : { rotateDegrees, height: 1280 };

  return (
    <Styled.ImageItem>
      <Styled.ImageWrapper>
        {shouldLoad ? (
          <TransformedImage
            path={url}
            alt={description}
            {...imageOptions}
            style={{ height: '100%' }}
          />
        ) : null}
      </Styled.ImageWrapper>
    </Styled.ImageItem>
  );
};
